<template>
  <button
    v-if="asset"
    class="deck-asset-row-component list-row-container"
    @click="$emit('card-row-clicked', card)"
  >
    <img
      v-if="thumbnailUrl"
      :src="thumbnailUrl"
      alt=""
      class="thumbnail"
    />
    <label-text
      :size="'sm'"
      data-test="asset-row-name"
    >
      {{ rowTitle }}
    </label-text>
    <div class="flex-1" />
    <div
      v-if="showPlay || asset.duration"
      class="action-container"
    >
      <icon
        v-if="showPlay"
        name="play-no-circle"
        class="icon"
      />
      <div
        v-if="asset.duration"
        class="text-xs font-medium duration-text"
        v-html="durationText"
      />
    </div>
    <div v-if="count" class="text-xs font-medium count-text">
      {{ count }}
    </div>
  </button>
</template>

<script>
import Icon from '@components/singletons/icon';
import LabelText from '@/components/ui/label-text.vue';


import Attachment from '@/classes/attachment';
import CardMixin from '@/mixins/card';
import CategoryThumbnailMixin from '@/mixins/categoryThumbnail';

export default {
  name: 'DeckAssetRow',
  components: { Icon, LabelText },
  mixins: [CardMixin, CategoryThumbnailMixin],
  props: {
    asset: {
      type: Object,
    },
    card: {
      type: Object,
    },
    deck: {
      type: Object,
    },
  },
  emits: ['card-row-clicked'],
  computed: {
    count() {
      return this.asset?.cards?.length || this.asset?.counts?.total || '';
    },
    rowTitle() {
      if (this.card?.isTopicCard && this.card.title) {
        return this.card.title;
      }
      return this.asset?.assetTitle || this.card?.title;
    },
    durationText() {
      return this.formatDuration(this.asset.metadata?.duration);
    },
    showPlay() {
      if (this.asset.assetType === 'Attachment') {
        return this.asset.mediaType !== 'image' && this.asset.mediaType !== 'biodigital';
      }
    },
  },
  methods: {
    formatDuration(duration) {
      return Attachment.formatDuration(duration, true);
    },
  },
};
</script>

<style lang="scss" scoped>
.deck-asset-row-component {
  .thumbnail {
    height: 48px;
    object-position: center;
    object-fit: cover;
    mix-blend-mode: multiply;
    border-radius: var(--radius-xs);
  }

  .count-text {
    border: 1.5px solid var(--border-secondary);
    padding: var(--spacing-xxs) var(--spacing-md);
    border-radius: var(--radius-full);
    color: var(--utility-gray-600);
  }

  .action-container {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: rem-calc(40);
    gap: 0.25rem;
    border: 1.5px solid var(--border-secondary);
    padding: var(--spacing-xxs) var(--spacing-md);
    border-radius: var(--radius-full);

    .duration-text {
      color: var(--utility-gray-600);
    }

    .icon {
      max-height: 9.1px;
      max-width: 7.1px;
    }
  }

  &:hover {
    background-color: #F1F4F8;
  }
}
</style>
